import OutOfOfficeComponent from 'components/marketingSite/outOfOffice/OutOfOfficeComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Script from 'next/script';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type OutOfOfficePageProps = WithBaseUrl;

const OutOfOfficePage: React.FC<OutOfOfficePageProps> = ({ baseUrl }) => {
  const { t } = useI18n('out-of-office');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('out-of-office.page_title')}
        url={APP_URLS.outOfOffice}
        desc={t('out-of-office.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_out_of_office.png'
        )}`}
        indexable={true}
      />
      <Script
        id="outOfOfficeLd"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `
        {
  "@context": "https://schema.org",
  "@type": "Newsletter",
  "name": "${t('out-of-office.page_title')}",
  "url": "https://www.getmanfred.com/out-of-office",
  "description": "${t('out-of-office.page_description')}",
  "publisher": {
    "@type": "Organization",
    "name": "Manfred",
    "url": "https://www.getmanfred.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000",
    }
  },
  "audience": {
    "@type": "BusinessAudience",
    "name": "Empresas tecnológicas"
  },
  "mainEntityOfPage": "https://www.getmanfred.com/out-of-office"
}
        `
        }}
      />
      <OutOfOfficeComponent />
    </>
  );
};

export default OutOfOfficePage;

export const getStaticProps: GetStaticProps<OutOfOfficePageProps> = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'out-of-office'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
